module.exports = __webpack_public_path__ + "img/vlLeafMark_green_noBG.ee88d329.png";